import { useLocation } from 'react-router-dom'

export const usePath = (): {
  root: string;
  path: string;
  getResolvedPath: (path: string) => string;
} => {
  const location = useLocation()
  const paths = location.pathname.split('/')?.filter((path) => path !== '')
  const currentPath = paths?.[paths.length - 1] ?? '/console'
  const currentPathRoot = paths?.[1] ?? '/console'
  const getResolvedPath = (path: string): string => {
    let resolvedPath = location.pathname
    if (path) {
      paths.push(path)
      paths.unshift('')
      resolvedPath = paths.join('/')
    }
    return resolvedPath
  }

  return { root: currentPathRoot, path: currentPath, getResolvedPath }
}
